export default __webpack_public_path__ + "static/media/succession_planning_type.705a735d.svg";